import React from "react";
import { IRemoveSupplyContext } from "./types";

export const RemoveSupplyContext = React.createContext<IRemoveSupplyContext>({
  displayingSnackbar: null,
  setDisplayingSnackbar: () => {},
  displayingAlertBanner: null,
  setDisplayingAlertBanner: () => {},
  premiseAddress: null,
  setPremiseAddress: () => {},
  draftInfo: null,
  setDraftInfo: () => {},
  activeSection: "premiseSection",
  setActiveSection: () => {},
  sectionVisibility: {
    supportingDocumentsSection: false,
  },
  setSectionVisibility: () => {},
});
